import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { MESSAGES } from '../../../../constants';
import { headerActions } from '../../../common/reducers/header';
import { selectItems } from '../../../common/selectors/chat';
import { selectIsEnabled } from '../../../common/selectors/header';
import { navigationControl } from '../../../util/navigationControl';

/**
 * Listening to chat items to enable the button when the chat is in a state where user is engaged
 */
export const useEnableResetListener = () => {
  const isEnabled = useSelector(selectIsEnabled);
  const items = useSelector(selectItems);
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      !isEnabled &&
      !navigationControl.isLocked &&
      items.filter(({ type }) => [MESSAGES.USER_MESSAGE, MESSAGES.CONNECTING_AGENT].includes(type)).length > 0
    ) {
      dispatch(headerActions.enableButton());
    }
  }, [isEnabled, items, dispatch]);
};
